import React, { useState } from "react";
import { Form } from "tabler-react";
import { helper } from '../../utils/helpers/helper';
import "./style.css";


export default function Toggle(props) {
    
    const {
        name,
        value,
        isChecked,
        label,
        onChange,
        // obj
    } = props;
    const [toggleOn, setToggleOn] = useState(isChecked);    

    const changeHandler = (props) => {
        const toggleVal = !toggleOn;
        setToggleOn(toggleVal);
        onChange(value, toggleVal);
    }
    
    return (
        <label className="custom-switch toggle">
            
            <span className="custom-switch-description">
                <Form.Group 
                    label={!helper.isEmpty(label)? helper.ucfirst(label) : ''} 
                    className="mt-4"
                ></Form.Group>
            </span>
            
            <input 
                type="checkbox" 
                name={name} 
                className="custom-switch-input" 
                value={!helper.isEmpty(value)? value : ''} 
                onChange={changeHandler}
                checked={toggleOn}
            />

            <span className="custom-switch-indicator"></span>

        </label>
        
    );
}